import './App.css';
import RouteScanSummariesView from './components/Routes/RouteScanSummariesView';
import PickupSummaryView from './components/Routes/Pickups/PickupSummaryView';
import RoutePickupDetailsView from './components/Routes/Pickups/RoutePickupDetailsView';
import { Routes, Route } from 'react-router-dom';
import RouteParcelsView from './components/Routes/RouteParcelsView';
import Logo from './images/Logo';
import NavigationMenu from './components/NavigationMenu/NavigationMenu';
import axios from 'axios';

function App() {
  axios.interceptors.response.use(
      response => response, error => {
          if(error.response.status === 401) window.location.href = window.origin;
      }
  );

    return (
      <div className="w-screen">

        <header className="border-4 border-white grid grid-cols-12 w-screen bg-gradient-to-b from-white to-tpc-portal-banner-dark">
          <div className="col-span-2">
            <Logo dark={true} height="h-12 md:h-16"></Logo>
          </div>
          <div className="col-span-8 align-middle text-center text-2xl md:text-5xl p-3 font-bold text-gls-logo-blue">
            TPC PORTAL
          </div>
          <div className="col-span-12">
            <NavigationMenu></NavigationMenu>
          </div>
        </header>
        
        <div className="justify-center w-screen">
            <Routes>
              <Route path="/" element={<RouteScanSummariesView/>} />
              <Route path="/pickups" element={<PickupSummaryView/>}/>
              <Route path="/pickups/:routeNumber" element={<RoutePickupDetailsView/>} />
              <Route path="/route/:routeNumber" element={<RouteParcelsView/>}/>
            </Routes>
        </div>

      </div>
  );
}

export default App;
